import { useMutation } from '@tanstack/react-query';
import mockFoxentrySearchCompanyRequest from 'pages/Registration/EmployerInfo/mockFoxentrySearchCompanyRequest';
import { FoxentryApiResponse } from './FoxentryApiTypes';
import useSmartlook from '../../useSmartlook';
import useError from '../../useError';
import { sortCompaniesWithCzechFirst } from './showCzechCompaniesFirst';

type UseCompaniesByNameMutationParams = {
  companyName: string;
};

export const useCompaniesByNameMutation = () => {
  const { showError } = useError();
  const { error } = useSmartlook();

  return useMutation({
    mutationFn: async ({
      companyName,
    }: UseCompaniesByNameMutationParams): Promise<FoxentryApiResponse> => {
      try {
        if (import.meta.env.VITE_FEATURE_FOXENTRY_MOCK === 'true') {
          const mockedResponse = await mockFoxentrySearchCompanyRequest(
            companyName,
          );
          return mockedResponse;
        }

        const result = await fetch('https://api.foxentry.com/company/search', {
          method: 'post',
          body: JSON.stringify({
            request: {
              query: { type: 'name', value: companyName },
              options: { dataScope: 'extended' },
            },
          }),
          headers: {
            authorization: `Bearer ${import.meta.env.VITE_FOXENTRY_API_KEY}`,
          },
        });
        const fetchedResult: FoxentryApiResponse = await result.json();

        return sortCompaniesWithCzechFirst(fetchedResult);
      } catch (e) {
        error(
          '[useCompaniesByNameMutation][https://api.foxentry.com/company/search]',
          e,
        );
        if (e instanceof Error) {
          showError(e);
        }
        throw e;
      }
    },
  });
};
